document.addEventListener("DOMContentLoaded", async () => {
  const shopifyId = window.shopifyId;

  // Define the order of layer types
  const layerTypesOrder = [
    "mat",
    "leather",
    "base",
    "heel-pad",
    "stitching",
    "logos",
    "border",
    "border-stitching",
  ];

  const groupedIconsOrder = [
    "mat",
    "leather",
    "base",
    "heel-pad",
    "stitching",
    "logos",
    "border",
    "border-stitching",
  ];

  const layerTypeNames = {
    mat: "Mat",
    leather: "Leather color",
    base: "Base",
    border: "Border",
    "heel-pad": "Trim color",
    stitching: "Stitching",
    logos: "Latest Custom Designs by Customers",
    "border-stitching": "Border Stitching",
  };

  try {
    const response = await fetch(
      `https://us-central1-autowin-87b0e.cloudfunctions.net/getProductWithLayers?shopifyId=${shopifyId}`
    );
    const data = await response.json();

    console.log("Product Data:", data.product);
    console.log("Layers:", data.product.layers);
    console.log("Icons:", data.icons);
    localStorage.setItem(shopifyId, JSON.stringify(data.product));
    window[shopifyId] = data.product;

    const propertiesContainer = document.getElementById("layers-properties");
    const layersContainer = document.getElementById("layers-container");
    const iconsContainer = document.getElementById("icons-container");
    const prefetchContainer = document.createElement("div");
    prefetchContainer.style.position = "fixed";
    prefetchContainer.style.top = "-10000px";
    prefetchContainer.style.left = "1000000px";
    document.body.appendChild(prefetchContainer);

    // Function to render selected layers
    function renderLayers(selectedLayers) {
      layersContainer.innerHTML = ""; // Clear existing layers
      // Sort selected layers according to the predefined order
      selectedLayers.sort(
        (a, b) =>
          layerTypesOrder.indexOf(a.layerIcon.type) -
          layerTypesOrder.indexOf(b.layerIcon.type)
      );

      selectedLayers.forEach((layer, index) => {
        const layerElement = document.createElement("img");

        if (layer.layerIcon.type !== "base") {
        const property = document.createElement("input");
        property.type = "hidden";
        property.name = `properties[${layer.layerIcon.type}]`;
        property.value = layer.layerIcon.name;
        propertiesContainer.appendChild(property);
        }
        
        layerElement.src = layer.url;
        layerElement.alt = layer.layerIcon.name;
        layerElement.classList.add("styles-picker-layer");
        layerElement.style.zIndex = index; // Set z-index based on sorted order
        layersContainer.appendChild(layerElement);
      });
    }

    // Prefetch all layers
    data.product.layers.forEach((layer) => {
      const prefetchLayer = document.createElement("img");
      prefetchLayer.src = layer.url;
      prefetchLayer.alt = layer.layerIcon.name;
      prefetchContainer.appendChild(prefetchLayer);
    });

    // Group icons by type
    const groupedIcons = data.icons.reduce((acc, icon) => {
      const type = icon.type;
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(icon);
      return acc;
    }, {});

    // Object to track selected icons
    const selectedIcons = {};

    // Preselect the first icon of each type by default
    for (const type in groupedIcons) {
      const firstIcon = groupedIcons[type][0];
      selectedIcons[type] = data.product.layers.find(
        (layer) => layer.layerIcon.id === firstIcon.id
      );
    }

    // Render icons grouped by type and attach event listeners for toggling
    groupedIconsOrder.forEach((type) => {
      if (!groupedIcons[type]) return; // Skip if this type doesn't exist in groupedIcons

      const typeContainer = document.createElement("div");
      typeContainer.classList.add("styles-picker-type-container");
      typeContainer.innerHTML = `<h6 class="styles-picker-title">${
        layerTypeNames[type]
      }${
        selectedIcons[type] ? ` - (${selectedIcons[type].layerIcon.name})` : ""
      }</h6>`;

      if (groupedIcons[type].length < 2) {
        typeContainer.style.display = "none";
      }

      groupedIcons[type].forEach((icon) => {
        const iconElement = document.createElement("img");
        iconElement.src = icon.url;
        iconElement.alt = icon.name;
        iconElement.classList.add("styles-picker-icon");
        if (
          selectedIcons[type] &&
          selectedIcons[type].layerIcon.id === icon.id
        ) {
          iconElement.classList.add("styles-picker-selected");
        }
        iconElement.addEventListener("click", () => {
          // Toggle icon selection
          if (
            selectedIcons[type] &&
            selectedIcons[type].layerIcon.id === icon.id
          ) {
            // Do nothing since we want at least one icon selected per type
            return;
          } else {
            if (selectedIcons[type]) {
              // Deselect previously selected icon
              const previousIcon = document.querySelector(
                `img[data-type="${type}"].styles-picker-selected`
              );
              if (previousIcon)
                previousIcon.classList.remove("styles-picker-selected");
            }
            selectedIcons[type] = data.product.layers.find(
              (layer) => layer.layerIcon.id === icon.id
            );
            iconElement.classList.add("styles-picker-selected");
            // Update the title with the newly selected layer name
            const titleElement = typeContainer.querySelector(
              ".styles-picker-title"
            );
            titleElement.textContent = `${layerTypeNames[type]} - (${selectedIcons[type].layerIcon.name})`;
          }
          // Render selected layers
          const selectedLayers = Object.values(selectedIcons);
          renderLayers(selectedLayers);
        });
        iconElement.setAttribute("data-type", type);
        typeContainer.appendChild(iconElement);
      });
      iconsContainer.appendChild(typeContainer);
    });

    // Initial render of layers with preselected icons
    renderLayers(Object.values(selectedIcons));
  } catch (error) {
    console.error("Error fetching product data:", error);
  }
});
